import React from 'react'
// @ts-ignore no types
import config from '@adc/configment'
import * as graph from '@adc/sdk'
import * as blueprint from '@adc/blueprint'
// @ts-ignore no types
import { useApplicationSurvey } from '@adc/ui-adc'
import { useListingContext } from '../../context/listing'
import Gallery from '../../components/propertyGallery'

interface PropertyGalleryProps {
  featureFlags: any
}
const PropertyGallery = ({ featureFlags }: PropertyGalleryProps) => {
  // NOTE: This is here because even though we wish to show this status, the `biddingStatus` instance here only knows
  // about v1 logic so can never represent this condition correctly without either a) patching the UI, which we are
  // doing here, or b) changing the bidding status logic to take it into consideration, which we don't want to do until
  // we use the newer bidding service which should remove the need to care about this.
  const { listing } = useListingContext()
  const images = listing?.photos?.map(imageObject => {
    return imageObject?.file_descriptor.urls?.cdn || []
  })
  // eslint disables here since useApplicationSurvey response not typed yet
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
  const { manageSurveyVisibility } = useApplicationSurvey()

  const coords = {
    lat: listing?.primary_property?.summary?.address.coordinates?.lat,
    lng: listing?.primary_property?.summary?.address.coordinates?.lon,
  }
  let statusLabel = null
  if (!blueprint.listing.utils.isSparkOffer(listing)) {
    if (
      listing.listing_status === graph.enums.ListingStatus.AuctionInProgress
    ) {
      statusLabel = 'Auction In Progress'
    } else {
      statusLabel = listing.listing_status_label // was bStatus.statusLabel
    }
  }
  return (
    <Gallery
      config={{
        GOOGLE_MAP_CLIENT_ID: config.get('GOOGLE_MAP_CLIENT_ID'),
        GOOGLE_MAP_CHANNEL: config.get('GOOGLE_MAP_CHANNEL'),
      }}
      coords={coords}
      statusLabel={statusLabel}
      images={images}
      addressTuple={listing.formatted_address}
      featureFlags={featureFlags}
      listing={listing}
      manageSurveyVisibility={manageSurveyVisibility}
    />
  )
}

export default PropertyGallery
